import Pattern from '../ASSETS/ColorMatchPattern.png';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
